export const MAX_CARD_W = 450; // px
export const MAX_CARD_H = 780; // px
export const ENDCARD_FEED_MSG = "You've caught up on the latest news today.";
export const QN_SOCIAL_ICON_LIST = ["whatsapp", "facebook", "x", "copylink"];

export const QN_ARTICLE_COUNT_PER_PAGE = 5;

export const QN_ANALYTICS_EVENT_BASE = {
  event: "customEvent",
  clickCategory: "quick-news",
} as const;

export const SIZE_THRESHOLD_SMALL = 50;
export const SIZE_THRESHOLD_MEDIUM = 100;

export const ADDITION_SMALL = 30;
export const ADDITION_MEDIUM = 20;
export const ADDITION_LARGE = 10;
